module.exports = __webpack_public_path__ + "static/media/Simple-Line-Icons.6ac7320f.woff2";